export default {
    WAITING: 'PAYMENT_REQUEST.WAITING',
    PROCESSING: 'PAYMENT_REQUEST.PROCESSING',
    SUCCESS: 'PAYMENT_REQUEST.SUCCESS',
    CANCELLED: 'PAYMENT_REQUEST.CANCELLED',
    FAILED_FROM_SOURCE_SITE: 'PAYMENT_REQUEST.FAILED_FROM_SOURCE_SITE',
    SUCCESS_FROM_SOURCE_SITE: 'PAYMENT_REQUEST.SUCCESS_FROM_SOURCE_SITE'
};

